import { render, staticRenderFns } from "./Compliance.vue?vue&type=template&id=354a494c&"
import script from "./Compliance.vue?vue&type=script&lang=ts&"
export * from "./Compliance.vue?vue&type=script&lang=ts&"
import style0 from "./Compliance.vue?vue&type=style&index=0&id=354a494c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports